import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        { path: '/', name: 'base', redirect: '/login' },

        // 中转页
        {
            path: '/transit', name: 'transit',
            component: resolve => require(['@/view/transit'], resolve), meta: { keepAlive: true }
        },
        // 引导页
        {
            path: '/guide', name: 'guide',
            component: resolve => require(['@/view/guide'], resolve), meta: { keepAlive: true }
        },

        // 安徽地图数据表
        {
            path: '/mapAnHui', name: 'mapAnHui',
            component: resolve => require(['@/view/mapAnHui'], resolve), meta: { keepAlive: true }
        },

        // 登录
        { path: '/login', name: 'login', component: resolve => require(['@/view/login'], resolve), meta: { keepAlive: true } },

        // 首页
        { path: '/home', name: 'home', component: resolve => require(['@/view/home'], resolve), meta: { keepAlive: true } },

        // 区域板
        { path: '/selectArea', name: 'selectArea', component: resolve => require(['@/view/login/selectArea'], resolve), meta: { keepAlive: true } },

        // 分析
        {
            path: '/analysis', name: 'analysis',
            component: resolve => require(['@/view/analysis'], resolve), meta: { keepAlive: true }
        },

        // 上传
        { path: '/upload', name: 'upload', component: resolve => require(['@/view/upload'], resolve), meta: { keepAlive: true } },

        // 查询
        {
            path: '/query', name: 'query',
            component: resolve => require(['@/view/query'], resolve), meta: { keepAlive: true }
        },

        // 月报
        {
            path: '/monthlyReport', name: 'monthlyReport',
            component: resolve => require(['@/view/monthlyReport'], resolve), meta: { keepAlive: true }
        },

        // 材料清单
        {
            path: '/materialsBill', name: 'materialsBill',
            component: resolve => require(['@/view/materialsBill'], resolve), meta: { keepAlive: true }
        },

        // 预警设置
        {
            path: '/warning', name: 'warning',
            component: resolve => require(['@/view/warning'], resolve), meta: { keepAlive: true }
        },

        // 文库
        {
            path: '/library', name: 'library',
            component: resolve => require(['@/view/library'], resolve), meta: { keepAlive: true }
        },

        // 人员管理
        {
            path: '/personnelManagement', name: 'personnelManagement',
            component: resolve => require(['@/view/personnelManagement'], resolve), meta: { keepAlive: true }
        },

        // 字典管理
        {
            path: '/dictionary', name: 'dictionary',
            component: resolve => require(['@/view/dictionary'], resolve), meta: { keepAlive: true }
        },

        // 角色管理
        {
            path: '/role', name: 'role',
            component: resolve => require(['@/view/role'], resolve), meta: { keepAlive: true }
        },

        // 使用说明
        {
            path: '/instructions', name: 'instructions',
            component: resolve => require(['@/view/instructions/HelpIndex'], resolve), meta: { keepAlive: true }
        },

        // 系数编辑
        {
            path: '/formula', name: 'formula',
            component: resolve => require(['@/view/formula'], resolve), meta: { keepAlive: true }
        },

        // 片区管理
        {
            path: '/area', name: 'area',
            component: resolve => require(['@/view/area'], resolve), meta: { keepAlive: true }
        },

        // 人工价信息填报
        {
            path: '/fillContent', name: 'fillContent',
            component: resolve => require(['@/view/upload/fillContent'], resolve), meta: { keepAlive: true }
        },

        // 月报基础数据文本
        {
            path: '/priceTrend', name: 'priceTrend',
            component: resolve => require(['@/view/priceTrend/index'], resolve), meta: { keepAlive: true }
        },
        // 分部工程
        {
            path: '/division', name: 'division',
            component: resolve => require(['@/view/materialsBill/division'], resolve), meta: { keepAlive: true }
        },
        // 工种设置
        {
            path: '/typeOfWork', name: 'typeOfWork',
            component: resolve => require(['@/view/materialsBill/typeOfWork'], resolve), meta: { keepAlive: true }
        },
        // 大小工比例/工作时长
        {
            path: '/sizeWork', name: 'sizeWork',
            component: resolve => require(['@/view/materialsBill/sizeWork'], resolve), meta: { keepAlive: true }
        },
        // 合肥材料
        {
            path: '/csjOption', name: 'csjOption',
            component: resolve => require(['@/view/materialsBill/csjOption'], resolve), meta: { keepAlive: true }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js